export default "__VITE_ASSET__46b58953__"